<script setup>
  import { defineAsyncComponent } from "vue";

  const props = defineProps({
    product: Array,
    user: {
      type: Object,
      default: () => ({})
    }
  });
  import CanvasComponent from "./canvasComponent.vue";

  const getCanvasSize = (material) => {
    const sizeMap = {
      "25%": 25,
      "50%": 50,
      "65%": 65,
      "80%": 80
    };

    return sizeMap[material.svgSize] || 80;
  };
  const StockBadge = defineAsyncComponent(() => import("./StockBadge.vue"));
</script>

<template>

  <div class="container-cards" :key="product.id">
    <template v-for="color in product?.colors" :key="color.id">
      <div class="stock-dot-badge-content">
        <StockBadge
          :product-name="product.name"
          :showStock="product.showStock"
          :user="user"
          :stock_type="product.stock_type"
          :stock="product.stock"
          :made_to_order="product.made_to_order"
          :dot="true"
        />
      </div>
      <div class="card-prod">
        <div class="composite-image">
          <div v-if="product.featured_image.isSvg === true">
            <div class="card-dimensions"
                 v-if="product.packing_dimensions">
              <div class="content-canvas">
                <CanvasComponent
                  :svg-content="product.featured_image.svg"
                  :group-images="[{groupId:'group1', imageUrl:color.featured_image}]"
                  :width="getCanvasSize(product)"
                  :height="getCanvasSize(product)"
                  :pixel-ratio="1"
                />
              </div>
            </div>
            <div v-else>
              <CanvasComponent
                :svg-content="product.featured_image.svg"
                :group-images="[{groupId:'group1', imageUrl:color.featured_image}]"
                :width="80"
                :height="80"
                :pixel-ratio="1"
              />
            </div>
          </div>
          <div v-else-if="product.featured_image.isSvg === false">
            <div v-if="product.packing_dimensions">
              <div class="card-image">
                <img :src="product.featured_image.fullUrl" alt="">
              </div>
            </div>
            <div v-else>
              <div class="card-image">
                <img :src="product.featured_image.fullUrl" alt="">
              </div>
            </div>
          </div>

        </div>
        <div class="composite-info">
          <p class="reference">
            <a :href="product.slug">{{ product.reference }}</a>
          </p>
          <p>{{ product.packing_dimensions }}</p>
        </div>
      </div>

    </template>

  </div>


</template>

<style scoped>
  .composite-image{
    width: 80px;
  }
  .composite-info{
    .reference{
      a{
        text-decoration: none;
        color: #000;
        &:hover{
          text-decoration: underline;
        }

      }
    }
  }
</style>
